export enum URLS {
  Banner = '/banner',
  Employees = '/employees',
  Games = '/games',
  GamesMain = '/games/main',
  SettingGroups = '/settings-groups',
  Settings = '/settings',
  SocialLinks = '/social-links',
  Topics = '/contact-form/topics',
  Vacancies = '/vacancies',
  CareerForm = '/career-form',
  ContactUsForm = '/contact-form',
  PrivacyPolicy = '/privacy-policy-items',
  PrivacyPolicyTypes = '/privacy-policy-types'
}
